import {observer} from 'mobx-react-lite'
import * as React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Checklist} from 'yougile-model'
import {Icon} from '@components/common/base/icon'
import {cn} from '@containers/html-utils'
import {useChecklistStore} from './checklist-store'
import {LinkSmall} from './link-small'

type Props = {
  list: Checklist
  dragged?: boolean
  anyDragged?: boolean
}

const TwMainContainer = tw.div<{$dragged: boolean}>`
  p-8
  cursor-default
  flex
  flex-col
  items-start
  justify-start
  relative
  rounded-4

  ${p => {
    return p.$dragged ? '' : `hover:bg-interactive-l100`
  }}
`

const TwBorderContainer = tw.div<{$dragged: boolean}>`
  rounded-4
  w-full

  ${p => {
    return p.$dragged ? `shadow-border-1 shadow-grey-l60 bg-grey-l100` : ``
  }}
`

const TwContent = tw.div`
  w-full
  relative
`

const TwTitle = tw.div`
  text-sm-regular
  text-primary
  break-words
  pl-24
  whitespace-pre-wrap
`

const TwButtonsContainer = tw.div`
  w-full
  flex
  gap-16
  items-center
  justify-start
  mt-16
  text-xs-regular
  text-primary
  pl-24
  pr-8
`

const TwText = tw.div`
  text-xs-regular
  text-secondary
`

export const ChecklistTitle = observer((props: Props) => {
  const {list, dragged, anyDragged} = props
  const [state, store] = useChecklistStore()

  return (
    <TwBorderContainer $dragged={dragged}>
      <TwMainContainer $dragged={anyDragged}>
        <TwContent
          onClick={store.startEditTitle}
          className={cn(dragged && 'opacity-20')}
        >
          <Icon
            icon="IconListCheck"
            className="absolute left-0 top-0"
            color="primary"
          />
          <TwTitle>{list.title}</TwTitle>
        </TwContent>

        {state.unsavedTitle && !(dragged || anyDragged) && (
          <TwButtonsContainer>
            <TwText>{Lang.msg.editNotSaved1}</TwText>

            <LinkSmall color="primary" onMouseDown={store.startEditTitle}>
              {Lang.msg.editSee}
            </LinkSmall>

            <LinkSmall
              color="error"
              onMouseDown={store.cancelEditTitle}
              className="ml-auto"
            >
              {Lang.msg.editDiscard}
            </LinkSmall>
          </TwButtonsContainer>
        )}
      </TwMainContainer>
    </TwBorderContainer>
  )
})
